import { SelectOption } from '@app/@types'
import { isObject } from '../utils'
import useTranslation from './useTranslation'

interface useTranslationHelpersInterface {
	(): {
		convertEnumToOptions: (
			enumType: any,
			translationPrefix: string,
			sortVersions?: boolean
		) => SelectOption[]
	}
}

export const useTranslationHelpers: useTranslationHelpersInterface = () => {
	const { t } = useTranslation()

	const convertEnumToOptions = (
		enumType: any,
		translationPrefix: string,
		sortVersions?: boolean
	) => {
		if (isObject(enumType)) {
			const options = Object.keys(enumType).map<SelectOption>((q) => ({
				label: t(`${translationPrefix}.${enumType[q]}`),
				value: enumType[q],
			}))

			return options.sort((a, b) => {
				// Always put "Default" or "All" options first
				const isADefault = a.label.toLowerCase().match(/^(default|all)/)
				const isBDefault = b.label.toLowerCase().match(/^(default|all)/)

				if (isADefault && !isBDefault) return -1
				if (!isADefault && isBDefault) return 1

				// Sort versions semantically if requested
				if (sortVersions) {
					const versionA = a.label.replace(/^v/, '') // Remove 'v' prefix
					const versionB = b.label.replace(/^v/, '') // Remove 'v' prefix

					// Split version strings into parts (major.minor.patch)
					const partsA = versionA.split('.').map(Number)
					const partsB = versionB.split('.').map(Number)

					// Compare each part
					for (
						let i = 0;
						i < Math.max(partsA.length, partsB.length);
						i++
					) {
						const partA = partsA[i] || 0
						const partB = partsB[i] || 0

						if (partA !== partB) {
							return partA - partB
						}
					}

					return 0
				}

				// Otherwise sort alphabetically
				return a.label.localeCompare(b.label)
			})
		}

		return [] as SelectOption[]
	}

	return {
		convertEnumToOptions,
	}
}
